import React, { useState } from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiDownload, FiX, FiSmartphone } = FiIcons;

const InstallPrompt = ({ onInstall, onDismiss, isIOS, title, description }) => {
  const [isInstalling, setIsInstalling] = useState(false);

  const handleInstallClick = async () => {
    setIsInstalling(true);
    await onInstall();
    setIsInstalling(false);
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: 20 }}
      className="fixed bottom-4 left-4 right-4 bg-white rounded-xl shadow-xl p-6 border border-gray-200 z-50"
    >
      <div className="flex items-start justify-between">
        <div className="flex items-center">
          <div className="bg-blue-100 p-3 rounded-lg mr-4">
            <SafeIcon icon={FiSmartphone} className="text-blue-600 text-xl" />
          </div>
          <div>
            <h3 className="font-semibold text-gray-800 text-lg mb-1">{title}</h3>
            <p className="text-gray-600">
              {description}
            </p>
          </div>
        </div>
        <button 
          onClick={onDismiss}
          className="text-gray-400 hover:text-gray-600 transition-colors"
          aria-label="Dismiss"
        >
          <SafeIcon icon={FiX} className="text-xl" />
        </button>
      </div>
      
      <div className="mt-4 flex justify-end gap-3">
        <motion.button
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.98 }}
          onClick={onDismiss}
          className="px-4 py-2 text-gray-600 hover:text-gray-800 transition-colors"
        >
          Maybe Later
        </motion.button>
        
        <motion.button
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.98 }}
          onClick={handleInstallClick}
          disabled={isInstalling}
          className="px-6 py-2 bg-blue-600 text-white rounded-lg font-medium hover:bg-blue-700 transition-colors flex items-center shadow-md"
        >
          {isInstalling ? (
            <SafeIcon icon={FiIcons.FiLoader} className="animate-spin mr-2" />
          ) : (
            <SafeIcon icon={FiDownload} className="mr-2" />
          )}
          {isIOS ? "Add to Home Screen" : "Install App"}
        </motion.button>
      </div>
    </motion.div>
  );
};

export default InstallPrompt;